var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddUserModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 18,
    height: 18,
    transform: "translate(60 171)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_33",
    "data-name": "Mask Group 33",
    transform: "translate(-60 -171)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mail-notification-outline",
    transform: "translate(58.759 170.376)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M12.415,3.725h-9A1.552,1.552,0,0,0,1.862,5.276v9.311A1.552,1.552,0,0,0,3.414,16.14H16.4a1.552,1.552,0,0,0,1.552-1.552V9.273",
    fill: "none",
    stroke: "#9babc5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.242
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M4.345,6.208l5.587,4.345,3.375-2.548",
    fill: "none",
    stroke: "#9babc5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.242
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 1.86,
    cy: 1.86,
    r: 1.86,
    transform: "translate(14.898 3.108)",
    fill: "#9babc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M16.76,7.449a2.481,2.481,0,1,1,2.481-2.481A2.481,2.481,0,0,1,16.76,7.449Zm0-3.721A1.242,1.242,0,1,0,18,4.97a1.242,1.242,0,0,0-1.24-1.242Z",
    fill: "#9babc5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUserModal);
export default __webpack_public_path__ + "static/media/add-user-modal.3201d196ac68ef9526c663202c1f4377.svg";
export { ForwardRef as ReactComponent };